<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-4">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">
                {{ user?.name || "ชื่อ" }} {{ user?.surname || "" }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4"><p>Email</p></div>
            <div class="col-md-8">
              <p>
                {{ user?.email || "name@domain.com" }} &nbsp;
                <CheckCircleTwoTone
                  title="ยืนยันอีเมลแล้ว"
                  twoToneColor="#1890ff"
                  v-if="emailVerified"
                />
                <a-button
                  v-if="!emailVerified && isOwner"
                  @click="onSendEmail"
                  type="link"
                  :loading="sendingEmail"
                  :disabled="sentEmail"
                  >ยืนยัน</a-button
                >
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"><p>Role</p></div>
            <div class="col-md-8">
              <p>{{ user?.roleName || "Customer" }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"><p>Status</p></div>
            <div class="col-md-8">
              <p>
                {{
                  user?.isActived === null
                    ? "รอยืนยัน"
                    : user?.isActived
                    ? "เปิดใช้งาน"
                    : "ปิดการใช้งาน"
                }}
              </p>
            </div>
          </div>
          <div class="row">
            <a-menu
              v-model:selectedKeys="selectedKeys"
              mode="inline"
              @click="handleClick"
            >
              <a-menu-item key="userinfo"> ข้อมูลผู้ใช้ </a-menu-item>
              <a-menu-item
                key="changepassword"
                v-if="user?.providers === 'password'"
              >
                เปลี่ยนรหัสผ่าน
              </a-menu-item>
              <a-menu-item
                key="changepin"
                v-if="['admin', 'agent'].indexOf(user?.role > -1)"
              >
                เปลี่ยน PIN
              </a-menu-item>
              <a-menu-item
                key="admin"
                v-if="
                  this.role === 'admin' ||
                  (this.role === 'manager' && selects.role !== 'admin')
                "
              >
                เมนูแอดมิน
              </a-menu-item>
            </a-menu>
          </div>
          <div class="row">
            <div class="col-md-12">
              <n-button
                class="btn-outline-default"
                type="default"
                style="width: 100%"
                @click="
                  () => {
                    isAdmin ? onBack() : goToHome();
                  }
                "
              >
                {{ isAdmin ? "ไปหน้าจัดการผู้ใช้" : "กลับหน้าหลัก" }}</n-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="card" v-if="current === 'userinfo'">
        <Form @submit="onSaveInfo" :validation-schema="schema" v-if="user">
          <!-- <form method="#" action="#" v-on:submit.prevent="onSaveInfo"> -->
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h5 class="card-title">ข้อมูลผู้ใช้</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h6>ข้อมูลส่วนตัว</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- <fg-input label="ชื่อ" type="text" placeholder="Enter name" :value="user?.name">
                </fg-input> -->
                <vee-input
                  name="firstname"
                  type="text"
                  label="ชื่อ"
                  :placeholder="user?.name"
                  :value="user?.name"
                />
              </div>
              <div class="col-md-6">
                <!-- <fg-input
                  label="นามสกุล"
                  type="text"
                  placeholder="Enter surname"
                  :value="user?.surname"
                > -->
                <vee-input
                  name="lastname"
                  type="text"
                  :placeholder="user?.surname"
                  :value="user?.surname"
                  label="นามสกุล"
                />
                <!-- </fg-input> -->
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <h6>ช่องทางการติดต่อ</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- <fg-input
                  label="โทร"
                  type="tel"
                  :value="user?.tel"
                  placeholder="Enter phone number"
                >
                </fg-input> -->
                <vee-input
                  name="phonenumber"
                  type="tel"
                  :placeholder="user?.tel"
                  :value="user?.tel"
                  label="เบอร์โทรศัพท์"
                />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <a-button
                  type="primary"
                  :loading="infoSaveing"
                  html-type="submit"
                  >บันทึก</a-button
                >
                &nbsp;
                <a-button
                  type="default"
                  @click="
                    () => {
                      isAdmin ? onBack() : goToHome();
                    }
                  "
                  :disabled="infoSaveing"
                  >ยกเลิก</a-button
                >
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <h6>การผูกบัญชี</h6>
                <p>Coming soon..</p>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </Form>
      </div>
      <div class="card" v-if="current === 'changepassword'">
        <Form @submit="onSavePassword" :validation-schema="schemaPassword">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h5 class="card-title">เปลี่ยนรหัสผ่าน</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <vee-input
                  name="password"
                  type="password"
                  placeholder="Password"
                  label="รหัสผ่าน"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <vee-input
                  name="confirm_password"
                  type="password"
                  placeholder="Confirm Password"
                  label="กรอกรหัสผ่านอีกครั้ง"
                />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <a-button
                  type="primary"
                  :loading="passwordSaveing"
                  html-type="submit"
                  >บันทึก</a-button
                >
                &nbsp;
                <a-button
                  type="default"
                  @click="
                    () => {
                      isAdmin ? onBack() : goToHome();
                    }
                  "
                  :disabled="passwordSaveing"
                  >ยกเลิก</a-button
                >
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div class="card" v-if="current === 'changepin'">
        <Form @submit="onSavePin" :validation-schema="schemaPin">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h5 class="card-title">เปลี่ยน PIN</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <vee-input
                  name="oldpin"
                  type="password"
                  placeholder="Old PIN"
                  label="PIN เดิม"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <vee-input
                  name="pin"
                  type="password"
                  placeholder="PIN"
                  label="PIN (ตัวเลข 4 หลัก)"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <vee-input
                  name="confirm_pin"
                  type="password"
                  placeholder="Confirm PIN"
                  label="ยืนยัน PIN"
                />
              </div>
            </div>
            <br />
            <a-alert
              message="หมายเหตุ"
              description="PIN Code จะใช้เพื่อยืนยันการทำธุรกรรมที่เกี่ยวข้องกับ Wallet เช่น เติมเงิน"
              type="info"
              showIcon
            />
            <br />
            <div class="row">
              <div class="col-md-12">
                <a-button
                  type="primary"
                  :loading="pinSaveing"
                  html-type="submit"
                  >บันทึก</a-button
                >
                &nbsp;
                <a-button
                  type="default"
                  @click="
                    () => {
                      isAdmin ? onBack() : goToHome();
                    }
                  "
                  :disabled="pinSaveing"
                  >ยกเลิก</a-button
                >
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div class="card" v-if="current === 'admin'">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h5 class="card-title">เมนูแอดมิน</h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <div><p>สถานะ</p></div>
            </div>
            <div class="col-md-10">
              <a-select
                v-model:value="selects.status"
                style="min-width: 250px"
                placeholder="เลือกสถานะ"
                :options="selects.statuses"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div><p>บทบาท</p></div>
            </div>
            <div class="col-md-10">
              <a-select
                v-model:value="selects.role"
                style="min-width: 250px"
                placeholder="เลือกบทบาท"
                :options="selects.roles"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-10">
              <a-button
                type="primary"
                @click="onSaveRole"
                :loading="roleSaveing"
                >บันทึก</a-button
              >
              &nbsp;
              <a-button
                type="default"
                @click="
                  () => {
                    isAdmin ? onBack() : goToHome();
                  }
                "
                :disabled="roleSaveing"
                >ยกเลิก</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as configuration from "../../../middleware/configuration";
import * as userservice from "../../../services/user";
import * as paymentservice from "../../../services/payment";
import { message } from "ant-design-vue";
import firebase from "firebase";
import { Form } from "vee-validate";
import { VeeInput } from "@/components";
import * as Yup from "yup";
import { CheckCircleTwoTone } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

const key = "updatable";
export default {
  components: {
    Form,
    VeeInput,
    CheckCircleTwoTone,
  },
  methods: {
    onBack() {
      this.$router.push("/management/user");
    },
    goToHome() {
      this.$router.push("/game");
    },
    handleClick(e) {
      this.current = e.key;
    },
    async getUserDetail() {
      try {
        let res = await userservice.getUserDetail(this.$route.params.id);
        this.user = res.data;
        this.selects.role = res.data.roleName?.toLowerCase() || "customer";
        this.selects.status = res.data.isActived;
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.rolesLoaded = true;
      }
    },
    async getRoles() {
      try {
        let res = await userservice.getRoles();
        let start = false;
        res.data.map((m) => {
          start = start || this.role === m.name.toLowerCase();
          if (start) {
            this.selects.roles.push({
              value: m.name.toLowerCase(),
              label: m.name,
            });
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.rolesLoaded = true;
      }
    },
    onSaveRole() {
      this.roleSaveing = true;
      message.loading({ content: "กำลังบันทึก...", key });

      var setUserRole = firebase.app().functions().httpsCallable("setUserRole");

      let data = {
        uid: this.$route.params.id,
        role: this.selects.role,
        isactived: this.selects.status,
      };
      setUserRole(data)
        .then((res) => {
          message.success({ content: "บันทึกขอมูลสำเร็จ!", key, duration: 2 });
          this.getUserDetail();
        })
        .catch((err) => {
          message.error({
            content: "บันทึกขอมูลไม่สำเร็จ! " + err,
            key,
            duration: 2,
          });
        })
        .finally(() => {
          this.roleSaveing = false;
        });
    },
    onSaveInfo(values) {
      this.infoSaveing = true;
      let firstName = values.firstname;
      let lastName = values.lastname;
      let phoneNumber = values.phonenumber;
      let data = {
        firstName: firstName,
        lastName: lastName,
        displayName: `${firstName} ${lastName}`,
        phoneNumber: phoneNumber?.startsWith("+66")
          ? phoneNumber
          : phoneNumber?.startsWith("0")
          ? phoneNumber?.replace("0", "+66")
          : "",
        uid: this.$route.params.id,
      };
      var updateUser = firebase.app().functions().httpsCallable("updateUser");
      updateUser(data)
        .then((res) => {
          message.success({ content: "บันทึกขอมูลสำเร็จ!", key, duration: 2 });
          this.getUserDetail();
        })
        .catch((err) => {
          let msg =
            err.code === "invalid-argument"
              ? "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง"
              : err.message;
          message.error({
            content: "บันทึกขอมูลไม่สำเร็จ! " + msg,
            key,
            duration: 2,
          });
        })
        .finally(() => {
          this.infoSaveing = false;
          firebase
            .auth()
            .currentUser.getIdTokenResult(true)
            .then((result) => {});
        });
    },
    async onSavePassword(values) {
      this.passwordSaveing = true;
      let data = {
        uid: this.$route.params.id,
        password: values.password,
      };

      if (this.isOwner) {
        try {
          let user = await configuration.getCurrentUser();
          user.updatePassword(values.password).then(async () => {
            message.success({
              content: "บันทึกขอมูลสำเร็จ!",
              key,
              duration: 2,
            });

            var setCustomAgentClaims = firebase
              .app()
              .functions()
              .httpsCallable("setCustomAgentClaims");
            setCustomAgentClaims({ password: true });

            await this.getUserDetail();
          });
        } catch (error) {
          message.error({
            content: "บันทึกขอมูลไม่สำเร็จ! " + error.message,
            key,
            duration: 2,
          });
        } finally {
          this.current = "userinfo";
          this.selectedKeys = ["userinfo"];
          this.passwordSaveing = false;
        }
      } else {
        var updateUserAuthentication = firebase
          .app()
          .functions()
          .httpsCallable("updateUserAuthentication");
        updateUserAuthentication(data)
          .then(async (res) => {
            message.success({
              content: "บันทึกข้อมูลสำเร็จ!",
              key,
              duration: 2,
            });
            await this.getUserDetail();
          })
          .catch((err) => {
            message.error({
              content: "บันทึกขอมูลไม่สำเร็จ! " + err.message,
              key,
              duration: 2,
            });
          })
          .finally(() => {
            this.current = "userinfo";
            this.selectedKeys = ["userinfo"];
            this.passwordSaveing = false;
          });
      }
    },
    async onSendEmail() {
      try {
        this.sendingEmail = true;
        message.loading({ content: "กำลังดำเนินการ...", key });
        let user = await configuration.getCurrentUser();
        user.sendEmailVerification().then(() => {
          this.sentEmail = true;
          message.success({
            content:
              "ส่งอีเมลไปที่ " +
              this.user?.email +
              " สำเร็จแล้ว กรุณาตรวจสอบที่อีเมลของท่าน",
            key,
            duration: 10,
          });
        });
      } catch (error) {
        message.error({
          content: "ส่งอีเมลไม่สำเร็จ! กรุณาลองอีกครั้ง",
          key,
          duration: 2,
        });
      } finally {
        this.sendingEmail = false;
      }
    },
    async onSavePin(values) {
      this.pinSaveing = true;
      let data = {
        uid: this.$route.params.id,
        oldPin: values.oldpin,
        pin: values.pin,
      };

      try {
        let res = await paymentservice.changePin(data);
        if (res) {
          message.success({ content: "บันทึกขอมูลสำเร็จ!", key, duration: 2 });
          var setCustomAgentClaims = firebase
            .app()
            .functions()
            .httpsCallable("setCustomAgentClaims");
          setCustomAgentClaims({ pin: true });
          this.current = "userinfo";
          this.selectedKeys = ["userinfo"];
        }
      } catch (error) {
        if (error.response.data.indexOf("Old PIN was wrong") > -1) {
          message.error({
            content: "PIN เดิมไม่ถูกต้อง",
            key,
            duration: 2,
          });
          return;
        }
        message.error({
          content: "บันทึกขอมูลไม่สำเร็จ! " + error.message,
          key,
          duration: 2,
        });
      } finally {
        this.pinSaveing = false;
      }
    },
  },
  data() {
    return {
      uid: "",
      user: null,
      current: "userinfo",
      currentUser: null,
      selectedKeys: ["userinfo"],
      roleSaveing: false,
      infoSaveing: false,
      passwordSaveing: false,
      pinSaving: false,
      canAccess: null,
      isAdmin: false,
      isOwner: false,
      emailVerified: false,
      sendingEmail: false,
      sentEmail: false,
      selects: {
        role: "customer",
        rolesLoaded: false,
        roles: [],
        status: null,
        statusLoaded: false,
        statuses: [
          {
            value: true,
            label: "เปิดใช้งาน",
          },
          {
            value: false,
            label: "ปิดการใช้งาน",
          },
          {
            value: null,
            label: "รอยืนยัน",
          },
        ],
        role: "customer",
      },
    };
  },
  async mounted() {
    let isConfirmPassword = this.$route.params.isConfirmPassword;
    if (isConfirmPassword) {
      this.current = "changepassword";
      this.selectedKeys = ["changepassword"];
      message.warning("กรุณาเปลี่ยนรหัสผ่านก่อนเข้าใช้งาน");
      return;
    }
    let isConfirmPin = this.$route.params.isConfirmPin;
    if (isConfirmPin) {
      this.current = "changepin";
      this.selectedKeys = ["changepin"];
      message.warning("กรุณาเปลี่ยน PIN ก่อนเข้าใช้งาน");
      return;
    }
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    this.isOwner = this.uid === this.$route.params.id;
    let result = await configuration.getIdTokenResult(true);
    if (result) {
      this.emailVerified = result.claims?.email_verified;
      this.role = result.claims?.role || this.role;
      this.isAdmin =
        this.role === "admin" ||
        this.role === "manager" ||
        this.role === "staff";
      if (
        this.role === "admin" ||
        this.role === "manager" ||
        this.uid === this.$route.params.id ||
        this.role === "staff"
      ) {
        await this.getUserDetail();
        await this.getRoles();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },
  setup() {
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const schema = Yup.object().shape({
      firstname: Yup.string().label("The Name"),
      lastname: Yup.string().label("The Surname"),
      phonenumber: Yup.string()
        .nullable(true)
        .matches(phoneRegExp, "Phone number is not valid")
        .label("The Phone number")
        .transform((_, val) => (val === val ? val : null)),
    });
    const schemaPassword = Yup.object().shape({
      password: Yup.string().min(8).required().label("The Password"),
      confirm_password: Yup.string()
        .required()
        .oneOf([Yup.ref("password")], "Passwords do not match"),
    });
    const schemaPin = Yup.object().shape({
      oldpin: Yup.string().min(4).max(4).required().label("The old PIN"),
      pin: Yup.string().min(4).max(4).required().label("The PIN"),
      confirm_pin: Yup.string()
        .required()
        .oneOf([Yup.ref("pin")], "PIN do not match"),
    });
    return {
      schema,
      schemaPassword,
      schemaPin,
    };
  },
};
</script>

<style>
</style>